module.exports = __webpack_public_path__ + "img/W-QB60.6ac823c0.jpg";